<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("category") }}</h4>
        </div>
      </div>

      <div v-if="can('inventory.category', 'W')" class="page-btn">
        <a href="#" class="btn btn-added" data-bs-toggle="modal" data-bs-target="#create-modal">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_category") }}
        </a>
        <CreateModal @create_success="reloadTable" />
      </div>
    </div>

    <ThemeDataTable
      ref="categoryTable"
      table-id="CategoryTable"
      :fetch-data="fetchCategoriesPage"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("node") }}</th>
            <th class="no-sort text-end">{{ $t("action") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in rows" :key="category.id">
            <td>{{ category.node }}</td>
            <td class="action-table-data text-end">
              <div v-if="can('inventory.category', 'E')" class="edit-delete-action justify-content-end">
                <a class="me-2 p-2" href="#" @click.prevent="openEditModal(category)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ti ti-edit">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>

    <EditModal :selectedCategory="selectedCategory" @edit_success="reloadTable" />
  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import CreateModal from '@/views/admin_dashboard/category/CreateModal.vue';
import EditModal from '@/views/admin_dashboard/category/EditModal.vue';
import apiUrls from '@/urls';
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';

export default {
  components: {
    CreateModal,
    EditModal,
    ThemeDataTable,
  },
  data() {
    return {
      selectedCategory: {},
    };
  },
  methods: {
    openEditModal(category) {
      this.selectedCategory = category;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('edit-modal'));
        modal.show();
      });
    },

    reloadTable() {
      this.$refs.categoryTable?.reload?.();
    },

    async fetchCategoriesPage({ draw, start, length, search, orderColumn, orderDir }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
      };

      const response = await this.$axios.get(apiUrls.categories.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
};
</script>

<style scoped>
:deep(table .edit-delete-action.justify-content-end) {
  justify-content: flex-end !important;
}
:deep(td.action-table-data.text-end) {
  text-align: right !important;
}
</style>
